// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.skip-main[data-v-71246c7f]{left:-999px;position:absolute;top:auto;width:1px;height:1px;overflow:hidden;z-index:-999}a.skip-main[data-v-71246c7f]:active,a.skip-main[data-v-71246c7f]:focus{color:#fff;background-color:#000;left:auto;top:auto;width:30%;height:auto;overflow:auto;margin:.5rem 35%;padding:.25rem;border-radius:1rem;border:.25rem solid #d6b034;text-align:center;font-size:1.125rem;z-index:999}", ""]);
// Exports
module.exports = exports;
